export function useAnonymisation(root: any | null = null) {
    const extractIntervalRules = (rules: Array<Array<string>>, level: any, hasStats: boolean, options: any) => {
        if (hasStats && level) {
            rules.push(['Field values were generalized in numerical intervals of size', `${level.interval}.`]);
        } else if (!hasStats) {
            let intervalValues = '';
            for (let i = 0; i < options.levels.length; i += 1) {
                intervalValues += `${options.levels[i].interval}, `;
            }
            intervalValues = intervalValues.slice(0, -2);
            rules.push([
                'Field values are likely to be generalized in numerical intervals of size',
                `${intervalValues}.`,
            ]);
            if (options.leveling === 'auto') {
                rules.push(['Additional generalization levels may be applied.']);
            }
        }
    };

    const extractNumericalGroupRules = (rules: Array<Array<string>>, level: any, hasStats: boolean, options: any) => {
        if (hasStats && level) {
            level.forEach((group: any) => {
                let { label } = group;
                if (!label || label.length === 0) {
                    label = `${group.from}-${group.to}`;
                }
                rules.push([
                    'Field values from',
                    group.from,
                    'to',
                    group.to,
                    'were replaced with the label',
                    `'${label}'.`,
                ]);
            });
        } else if (!hasStats) {
            options.levels[0].forEach((group: any) => {
                let { label } = group;
                if (!label || label.length === 0) {
                    label = `${group.from}-${group.to}`;
                }
                rules.push([
                    'Field values from',
                    group.from,
                    'to',
                    group.to,
                    'are likely to be replaced with the label',
                    `'${label}'.`,
                ]);
            });
            if (options.leveling === 'auto' || options.levels > 1) {
                rules.push(['Additional generalization levels may be applied.']);
            }
        }
    };

    const getDatetimeText = (level: number, type: string) => {
        const datetimeParts = ['seconds', 'minutes', 'hours', 'day', 'month', 'year (decade)'];
        const dateParts = ['day', 'month', 'year (decade)'];
        const timeParts = ['seconds', 'minutes', 'hours'];
        if (type === 'datetime') {
            return datetimeParts[level - 1];
        }
        if (type === 'date') {
            return dateParts[level - 1];
        }
        return timeParts[level - 1];
    };

    const extractDatetimeRules = (
        rules: Array<Array<string>>,
        level: any,
        hasStats: boolean,
        type: string,
        options: any,
    ) => {
        if (hasStats) {
            let datetimeValues = '';
            for (let i = 1; i <= level; i += 1) {
                datetimeValues += `${getDatetimeText(i, type)}, `;
            }
            datetimeValues = datetimeValues.slice(0, -2);
            rules.push(['The following parts have been', 'reset', `from the ${type} values:`, `${datetimeValues}.`]);
        } else {
            rules.push([
                'Field values are likely to be generalized by',
                'reseting',
                'different parts of the datetime, starting from',
                'seconds',
                'until',
                `${getDatetimeText(options.finalLevel, type)}.`,
            ]);
        }
    };

    const extractMaskingRules = (rules: Array<Array<string>>, level: any, hasStats: boolean, options: any) => {
        if (hasStats && level === 1) {
            rules.push([
                'The',
                'last',
                'character of the values was replaced with the masking character',
                `'${options.maskingChar}'.`,
            ]);
        } else if (hasStats && level > 1) {
            rules.push([
                'The',
                `last ${level}`,
                'characters of the values were replaced with the masking character',
                `'${options.maskingChar}'.`,
            ]);
        } else if (!hasStats) {
            rules.push([
                'Field values are likely to be obscured by the masking character',
                `'${options.maskingChar}'.`,
            ]);
        }
    };

    const extractBooleanRules = (rules: Array<Array<string>>, hasStats: boolean, options: any) => {
        let verb = 'are likely to be';
        if (hasStats) {
            verb = 'were';
        }
        if (options.show) {
            rules.push([`Field values ${verb} generalized into the`, 'same group.']);
        } else {
            rules.push([`Field values ${verb}`, 'replaced', 'with the character', `'*'.`]);
        }
    };

    return {
        extractIntervalRules,
        extractNumericalGroupRules,
        extractDatetimeRules,
        extractMaskingRules,
        extractBooleanRules,
    };
}
